import React from "react";
import {
    Avatar,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { OperatingArea } from "@optimusride/client-library/@types/grpc/site";
import { SPACING_16 } from "../../common/styles/spacing";
import { FONT_0_75, HEADING_FONT } from "../../common/styles/fonts";
import { GRAY_900 } from "../../common/styles/colors";
import { getInitials } from "../../common/utils";

const SITE_SELECTOR_ID = "operating-site-selector";

const StyledSiteSelector = styled.div`
    position: relative;

    color: ${GRAY_900}
    font-size: ${FONT_0_75};
    font-weight: bold;
`;

const StyledFormControl = styled(FormControl)`
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: ${SPACING_16};

    height: 0;
    opacity: 0;
`;

const StyledSiteInitials = styled.span`
    font-family: ${HEADING_FONT};
    color: ${GRAY_900};
    font-size: ${FONT_0_75};
    font-weight: bold;
`;

export default ({
    siteOptions,
    selectedSite: { name: selectedSiteName },
    onSelect,
    open,
}: {
    siteOptions: OperatingArea[];
    selectedSite: OperatingArea;
    onSelect: (id: string) => void;
    open: boolean;
}) => {
    const { t } = useTranslation();

    const initials = getInitials(selectedSiteName);

    return (
        <StyledSiteSelector>
            <Avatar>
                <StyledSiteInitials>
                    {initials}
                </StyledSiteInitials>
            </Avatar>
            <StyledFormControl>
                <InputLabel id={SITE_SELECTOR_ID}>
                    {t("sidebar.siteSelector")}
                </InputLabel>
                <Select
                    labelId={SITE_SELECTOR_ID}
                    id={SITE_SELECTOR_ID}
                    open={open}
                    value={initials}
                    onChange={(e) => onSelect(e.target.value as string)}
                >
                    {siteOptions
                        .map(({ id, name }) => (
                            <MenuItem key={id} value={getInitials(name)}>
                                {name}
                            </MenuItem>
                        ))}
                </Select>
            </StyledFormControl>
        </StyledSiteSelector>
    );
};
